import { render, staticRenderFns } from "./SlideCustomerList.vue?vue&type=template&id=b0c03bc6&scoped=true&"
import script from "./SlideCustomerList.vue?vue&type=script&lang=js&"
export * from "./SlideCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./SlideCustomerList.vue?vue&type=style&index=0&id=b0c03bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c03bc6",
  null
  
)

export default component.exports